import { is, List } from 'immutable';

interface iConfig {
    validator: (value: any, defaultValue?: any) => Promise<any>;
    message: string;
    defaultValue?: any;
}

/**
 * value equal
 * @param value
 * @param defaultValue
 * @param ignoreCasing
 */
export function isEqual(value: any, defaultValue: any, ignoreCasing: boolean = true) {
    return (typeof value === 'string' && typeof defaultValue === 'string' && ignoreCasing)
        ? value.toLowerCase() === defaultValue.toLowerCase()
        : is((value ? List(value) : value), (defaultValue ? List(defaultValue) : defaultValue));
}

/**
 * async validator wrapper
 * @param validator
 * @param message
 * @param defaultValue
 * @param ignoreCasing
 * @param rest
 * @param outCallback
 */
export default ({ validator, message }: iConfig, { defaultValue, ignoreCasing, ...rest }: any = {}, outCallback?: any) => ({
    validator: async (rule: any, value: any, callback: Function) => {
        try {
            // whether the value changes
            if (isEqual(value, defaultValue, ignoreCasing)) {
                callback();
            } else {
                const res = await validator(value, rest);
                // async-validator callback
                callback();
                // external component callback
                outCallback && outCallback(res);
            }
        } catch (err) {
            callback(err);
            outCallback && outCallback(false);
        }
    },
    message
});
